<template>
  <div class="hall-fluency" :class="'fluency-level-' + fluencyLevel">
    <i v-for="(item, index) in max"
       :key="index"
       class="fluency-item"
       :class="{ active: index <= fluencyLevel - 1 }"></i>
    <span class="fluency-desc">{{ fluencyDesc }}</span>
  </div>
</template>

<script>
export default {
  name: 'HallFluency',
  props: {
    fluencyLevel: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      max: 5
    }
  },
  computed: {
    fluencyDesc () {
      const that = this;
      let message = '';
      switch (that.fluencyLevel) {
        case -1:
          // 隐藏人流量显示
          break;
        case 1:
          message = '当前排队人数极少'
          break;
        case 2:
          message = '当前排队人数较少'
          break;
        case 3:
          message = '当前排队人数适中'
          break;
        case 4:
          message = '当前大厅较为拥挤'
          break;
        case 5:
          message = '当前大厅非常拥挤'
          break;
        default:
          break;
      }
      return message;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.hall-fluency{
  font-size: 12px;
  color: $colorTextSecondary;
  .fluency-item{
    display: inline-block;
    width: 3px;
    height: 12px;
    margin-right: 2px;
    vertical-align: middle;
    background: #eee;
    border-radius: 2px;
  }
  .fluency-desc{
    margin-left: 8px;
    vertical-align: middle;
  }
  &.fluency-level-1{
    .fluency-item{
      background-color: #D4F9EC;
      &.active{
        background-color: #44CC9E;
      }
    }
    .fluency-desc{
      color: #44CC9E;
    }
  }
  &.fluency-level-2{
    .fluency-item{
      background-color: #D4F9EC;
      &.active{
        background-color: #44CC9E;
      }
    }
    .fluency-desc{
      color: #44CC9E;
    }
  }
  &.fluency-level-3{
    .fluency-item{
      background-color: #FFEDD7;
      &.active{
        background-color: #F8A63C;
      }
    }
    .fluency-desc{
      color: #F8A63C;
    }
  }
  &.fluency-level-4{
    .fluency-item{
      background-color: #f9dcd7;
      &.active{
        background-color: #df5439;
      }
    }
    .fluency-desc{
      color: #df5439;
    }
  }
  &.fluency-level-5{
    .fluency-item{
      background-color: #f9dcd7;
      &.active{
        background-color: #a51f05;
      }
    }
    .fluency-desc{
      color: #a51f05;
    }
  }
}
</style>
